export const PRIVACY_ERROR_MESSAGES: Record<string, string> = {
  PRIVACY_CONFIRMATION_MISMATCH: 'O e-mail digitado não é o desta conta.',
  PRIVACY_LAST_OWNER:
    'Você é o único proprietário de uma imobiliária. Transfira a propriedade para outra pessoa ou exclua a imobiliária antes de excluir sua conta.'
}
